import React from "react";
import Grid from "@material-ui/core/Grid";
import { Label as FormLabel } from "../../typography/FormLabel";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  message: string;
};

const useStyles = makeStyles((theme) => ({
  root: {}
}));

export function FormError(props: Props) {
  const classes = useStyles({});
  return (
    <Grid item xs={12} className={classes.root}>
      <FormLabel color="error">{props.message}</FormLabel>
    </Grid>
  );
}
